var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Error Circle_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.99935 1.16797C10.2211 1.16797 12.8327 3.78014 12.8327 7.0013C12.8327 10.2225 10.2211 12.8346 6.99935 12.8346C3.7776 12.8346 1.16602 10.2225 1.16602 7.0013C1.16602 3.78014 3.7776 1.16797 6.99935 1.16797Z",
    fill: "#D64C4C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M7.00099 8.86902C6.55097 8.86902 6.18615 9.23413 6.18615 9.68451C6.18615 10.1349 6.55097 10.5 7.00099 10.5C7.45102 10.5 7.81584 10.1349 7.81584 9.68451C7.81584 9.23413 7.45102 8.86902 7.00099 8.86902ZM6.99923 3.5C6.58079 3.50015 6.23604 3.81551 6.18905 4.22164L6.18359 4.31688L6.18506 7.23383L6.19059 7.32906C6.23786 7.73516 6.58285 8.05027 7.00129 8.05012C7.41973 8.04997 7.76449 7.73461 7.81147 7.32848L7.81693 7.23324L7.81546 4.31629L7.80993 4.22106C7.76266 3.81496 7.41767 3.49985 6.99923 3.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCircleFill);
export default __webpack_public_path__ + "static/media/icon-error-circle-fill.aa0edb48ead3d7bd1b3e211e7a406ae1.svg";
export { ForwardRef as ReactComponent };